import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

const PrivacyLayout = lazy(() =>
  import('../modules/privacy/PrivacyLayout').then((m) => ({ default: m.PrivacyLayout }))
)
const PrivacyHubPage = lazy(() =>
  import('../modules/privacy/PrivacyHubPage').then((m) => ({ default: m.PrivacyHubPage }))
)
const ConsentPage = lazy(() =>
  import('../modules/privacy/ConsentPage').then((m) => ({ default: m.ConsentPage }))
)
const RightsPage = lazy(() =>
  import('../modules/privacy/RightsPage').then((m) => ({ default: m.RightsPage }))
)
const DeletionPage = lazy(() =>
  import('../modules/privacy/DeletionPage').then((m) => ({ default: m.DeletionPage }))
)
const DSARPage = lazy(() =>
  import('../modules/privacy/DSARPage').then((m) => ({ default: m.DSARPage }))
)
const AdminPrivacyDashboard = lazy(() =>
  import('../modules/privacy/admin/AdminPrivacyDashboard').then((m) => ({ default: m.AdminPrivacyDashboard }))
)

export const privacyRoutes: RouteObject[] = [
  {
    path: 'privacy',
    element: <PrivacyLayout />,
    children: [
      { index: true, element: <PrivacyHubPage /> },
      { path: 'consent', element: <ConsentPage /> },
      { path: 'rights', element: <RightsPage /> },
      { path: 'deletion', element: <DeletionPage /> },
      { path: 'dsar', element: <DSARPage /> },
      { path: 'admin', element: <AdminPrivacyDashboard /> },
    ],
  },
]
